import React, { useState } from "react";
import { PrimaryButton } from "office-ui-fabric-react";
import clsx from "clsx";
import { getMyTables } from "apis/myTableApi";
import { arrayValidation, getErrorApis, sortRows } from "utils/functions";
import { getPredefinedTablesById } from "apis/predefinedTableApi";
import { getColumn } from "apis/columnApi";
import { Checkbox, FormControlLabel, Grid, InputAdornment, TextField } from "@material-ui/core";
import { snackbarTypes } from "constants/globals";
import { getPredefinedTables } from "apis/predefinedTableApi";
import { PredefinedTableData } from "apis/models/predefinedTable";
import { myTableData } from "apis/models/myTable";
import { NewTable } from "./ExporterNewTable";
import { LabelValue } from "models/common";
import Dropdown from "taskpane/components/Common/Dropdown";
import Snackbar from "taskpane/components/Common/Snackbar";
import { getPredefinedTablesByFilters, getMyTablesByFilters } from "./helpers";
import { Props, TypeSnackbar } from "./types";
import { useStyles } from "./style";
import CardMoveTable from "taskpane/components/ExcelAddIn/CardMoveTable/cardMoveTable";
import { HeaderListData, MarketExcludedColumns } from "../constants";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
const intiTagsvalues = {
  label: "Mis tablas",
  value: "Mis tablas",
  length: null,
};
const intiTagsvalues1 = {
  label: "Tablas predefinidas",
  value: "Tablas predefinidas",
  length: null,
};

const dataSnackbarInit = {
  showSnackbar: false,
  severity: "",
  message: "",
  autoHideDuration: 0,
};

let finalArray: [];

let headerListData: HeaderListData[];

const SelectPredefinedTable = ({
  onClickMarket,
  setShowSpinner,
  handleCallback,
  onCutAddTable,
  onCopyAddTable,
  onPasteAddTable,
  cardPaste,
  cardTableEnabled,
}: Props) => {
  const [predefinedTables, setPredefinedTables] = useState<PredefinedTableData[]>([]);
  const [misTables, setMisTables] = useState<myTableData[]>([]);
  const [tagValues, setTagValues] = useState<LabelValue[]>([intiTagsvalues, intiTagsvalues1]);
  const [tagSelected, setTagSelected] = useState<string>("");
  const [misTableValue, setMistableValue] = useState<LabelValue[]>([]);
  const [predefinedTablevalue, setPredefinedTablevalue] = useState<LabelValue[]>([]);
  const [tableValues, setTableValues] = useState<LabelValue[]>([]);
  const [tableSelected, setTableSelected] = useState<string>("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dataSnackbar, setDataSnackbar] = useState<TypeSnackbar>(dataSnackbarInit);
  const [headerDataItem, setHeaderDataItem] = useState([]);
  const [responsestate, setResponsestate] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const [tableName, setTableName] = useState("");
  const [openExportNewTable, setopenExportNewTable] = useState(true);
  const [columnRender, setColumnRender] = useState(false);
  const [cardOpen, setCardOpen] = useState(true);
  const [checkedlist, setcheckedlist] = useState(["Instrumento"]);
  const [checked, setChecked] = useState(true);
  const [refreshInstrumentArray, setrefreshInstrumentArray] = useState();
  const [searchText, setSearchText] = useState("");
  const [checkAll, setCheckAll] = useState(false);

  const [name] = useState("");
  const classes = useStyles();
  let dropdownrendervalue = null;
  let instrumentArray = null;
  let valueData: any[] | ((prevState: string[]) => string[]);
  let misValue: React.SetStateAction<LabelValue[]>;
  let marketTypeId: any;
  let exchangeId: any;
  let valueTypeId: any;
  const fetchData = async () => {
    if (tagSelected === "Mis tablas") {
      setShowSpinner(true);
      const misdata = misTables.find((data) => String(data.widgetId) === String(dropdownrendervalue));
      const { description } = misdata;
      setTableName(description);

      instrumentArray = sortRows(
        misdata.instruments.map((data) => data.instrument),
        "symbol"
      );
    } else {
      setShowSpinner(true);
      const predefineTdabel = predefinedTables.find(
        (data) => String(data.predefinedTableId) === String(dropdownrendervalue)
      );
      const { predefinedTableId, name } = predefineTdabel;
      setTableName(name);

      try {
        //API CALL
        const resp = await getPredefinedTablesById(predefinedTableId);
        if (resp && resp.data && resp.data.length > 0) {
          const data = resp.data;
          instrumentArray = sortRows(
            data.map((data) => data.instrument),
            "symbol"
          );
          setResponsestate("success");
        } else {
          setColumnRender(false);
          setShowSpinner(false);

          throw resp;
        }
      } catch (error) {
        setShowSpinner(false);
        setResponsestate("error");

        setErrorStatus(true);
      }
    }
    if (arrayValidation(instrumentArray)) {
      setrefreshInstrumentArray(instrumentArray);
      marketTypeId = instrumentArray[0].marketTypeId;
      exchangeId = instrumentArray[0].exchangeId;
      valueTypeId = instrumentArray[0].valueTypeId;
    }
    setColumnRender(false);
    headerColumnArray();
    //API CALL
    getColumn(marketTypeId, exchangeId, valueTypeId)
      .then((respdata) => {
        if (respdata && respdata.data && respdata.data.length > 0) {
          headerListData = respdata.data.map((data: { description: any }) => ({
            Name: data.description,
            IsChecked: false,
          }));
          var columnExcludedList = [];
          if (marketTypeId == 1 && valueTypeId >= 13617 && valueTypeId <= 13620) {
            columnExcludedList = MarketExcludedColumns.filter((x) => x.Market == 123);
          } else {
            columnExcludedList = MarketExcludedColumns.filter((x) => x.Market == marketTypeId);
          }
          var columnList = columnExcludedList.map((e) => e.description.toLowerCase().trim());
          headerListData = headerListData.filter((x) => !columnList.includes(x.Name.toLowerCase().trim()));
          setHeaderDataItem(headerListData);
          finalArray = respdata.data;
          setShowSpinner(false);
          setColumnRender(true);
          setResponsestate("success");
        } else {
          finalArray = [];

          setResponsestate("error");
          setColumnRender(false);
          setShowSpinner(false);
          setErrorStatus(true);
        }
      })
      .catch((error) => {
        console.log(error);
        finalArray = [];
        setShowSpinner(false);
      });
  };

  const allSelectedItem = (e) => {
    setCheckAll(e.target.checked);

    var ele: any = [];
    var Seleccionar = document.getElementById("Seleccionar") as HTMLInputElement;
    ele = document.getElementsByName("headerColumns");

    valueData = ["Instrumento"];
    if (Seleccionar.checked) {
    }
    for (let i = 0; i < ele.length; i++) {
      ele[i].checked = e.target.checked;
      if (e.target.checked) {
        valueData.push(ele[i].value);
        for (let i = 0; i < headerListData.length; i++) {
          headerListData[i].IsChecked = true;
        }
        setHeaderDataItem(headerListData);
      } else {
        for (let i = 0; i < headerListData.length; i++) {
          headerListData[i].IsChecked = false;
        }
        setHeaderDataItem(headerListData);
        setcheckedlist(["Instrumento"]);
      }
    }
    setcheckedlist(valueData);

    handleCallback(valueData);
  };
  const handleChangeMarket = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDropdownOpen(true);
    setTableSelected("");
    const value = event.target.value;
    setTagSelected(value);

    if (value === "Mis tablas") {
      setShowSpinner(true);

      if (misTableValue.length === 0) {
        setShowSpinner(true);
        //API CALL
        getMyTables()
          .then((resp) => {
            if (resp && resp.data && resp.data.length > 0) {
              const tempMyTables = getMyTablesByFilters(resp.data);
              const filteredTempMyTables = tempMyTables.filter((x) => x.instruments.length > 0);
              setMisTables(filteredTempMyTables);
              misValue = tempMyTables.map((data) => ({
                label: `${data.description}`,
                value: data.widgetId,
                length: `${data.instruments.length} Instrumento`,
              }));
              setMistableValue(misValue);
              setTableValues(misValue);
              setShowSpinner(false);
            } else {
              setColumnRender(false);
              setErrorStatus(true);
            }
          })

          .catch((error) => {
            console.log(error);
            setShowSpinner(false);
          });
      } else {
        setMistableValue(misTableValue);
        setTableValues(misTableValue);
        setShowSpinner(false);
      }
    } else {
      let predefinedtablevaluve: React.SetStateAction<LabelValue[]>;
      setShowSpinner(true);
      if (predefinedTablevalue.length === 0) {
        getPredefinedTables()
          .then((resp) => {
            if (resp && resp.data) {
              let tempPredefinedTables = getPredefinedTablesByFilters(resp.data);
              setPredefinedTables(tempPredefinedTables);
              predefinedtablevaluve = tempPredefinedTables.map((data) => ({
                label: `${data.name}`,
                value: data.predefinedTableId,
                length: ``,
              }));
              setPredefinedTablevalue(predefinedtablevaluve);
              setTableValues(predefinedtablevaluve);
              setShowSpinner(false);
            } else {
              showSnackbar(snackbarTypes.ERROR, getErrorApis(resp), 5000);
              setErrorStatus(true);
            }
          })
          .catch((error) => {
            console.log(error);
            setTableValues([]);
            setShowSpinner(false);
          });
      } else {
        setPredefinedTablevalue(predefinedTablevalue);
        setTableValues(predefinedTablevalue);
        setShowSpinner(false);
      }
    }

    setSearchText("");
    setCheckAll(false);
    setColumnRender(false);
  };

  const handleclosesuccess = (close: boolean | ((prevState: boolean) => boolean)) => {
    setopenExportNewTable(close);
    setDropdownOpen(!dropdownOpen);
    setColumnRender(true);
    setTagSelected("");
    setColumnRender(false);
  };
  const handlecloseerror = (error: boolean | ((prevState: boolean) => boolean)) => {
    setDropdownOpen(!dropdownOpen);
    setColumnRender(true);
    setErrorStatus(error);
    setTagSelected("");
    setColumnRender(false);
  };

  const handleChangePredefinedTable = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setcheckedlist(["Instrumento"]);
    dropdownrendervalue = value;
    setTableSelected(value);
    fetchData();
    handleCallback(["Instrumento"]);
    setSearchText("");
    setCheckAll(false);
  };
  const checkedData = () => {};
  const handleChange = (event: any) => {
    setcheckedlist(["Instrumento"]);
    const value = event.target.value;

    if (value) {
      headerDataItem[0].IsChecked = true;
      if (event.target.checked) {
        const indexOfItem = checkedlist.indexOf(value);

        if (indexOfItem >= 0) {
          checkedlist.splice(indexOfItem, 1, value);
        } else {
          checkedlist.push(value);
        }

        headerDataItem.map((x) => {
          if (x.Name == value) {
            x.IsChecked = true;
            headerListData.map((x) => {
              if (x.Name === value) {
                x.IsChecked = true;
              }
            });
          }
        });

        setcheckedlist(checkedlist);
        handleCallback(checkedlist);
      } else {
        const filteredCheckList = checkedlist.filter((x) => x !== value);
        headerDataItem.map((x) => {
          if (x.Name == value) {
            x.IsChecked = false;
            headerListData.map((x) => {
              if (x.Name === value) {
                x.IsChecked = false;
              }
            });
          }
        });
        setcheckedlist(filteredCheckList);
        handleCallback(filteredCheckList);
      }
    }
  };
  const onClickRefreshData = () => {
    if (tableSelected) {
      onClickMarket(refreshInstrumentArray, tableName);
      setcheckedlist(checkedlist);
      handleCallback(checkedlist);
    }

    setopenExportNewTable(!openExportNewTable);
    setSearchText("");
  };

  function handleChangeValue(e: any) {
    setSearchText(e.target.value);
    if (e.target.value != "" && e.target.value != null) {
      setcheckedlist(["Instrumento"]);
      headerListData[0].IsChecked = true;
      var columnList = headerListData
        .filter((x) => {
          return x.Name.toLowerCase().includes(e.target.value.toLowerCase());
        })
        .map((x) => {
          let idx = x.Name.toLowerCase().indexOf(e.target.value.toLowerCase());
          if (idx >= 0) {
            let newText = [
              x.Name.substring(0, idx),
              x.Name.substring(idx, idx + e.target.value.length),
              x.Name.substring(idx + e.target.value.length),
            ];
            const obj = {
              ...x,
              newVal: newText,
            };
            return obj;
          }
          return x;
        });

      columnList = columnList.filter((x) => x.Name !== "Instrumento");

      columnList.unshift({ Name: "Instrumento", IsChecked: true });
      columnList.sort(function (a) {
        if (a.IsChecked == true) {
          return -1;
        }
        if (a.IsChecked == false) {
          return 1;
        }
        return 0;
      });
      setcheckedlist(checkedlist);
      setHeaderDataItem(columnList); //TODO
    } else {
      setHeaderDataItem(headerListData);
    }
  }

  const showSnackbar = (severity: string, message: string, autoHideDuration: number) => {
    setDataSnackbar({
      showSnackbar: true,
      severity,
      message,
      autoHideDuration: Number(autoHideDuration),
    });
  };

  const handleCloseSnackbar = () => {
    setDataSnackbar({
      showSnackbar: false,
      severity: "",
      message: "",
      autoHideDuration: 0,
    });
  };
  let datatable = true;
  if (Office.context.requirements.isSetSupported("ExcelApi", "1.9")) {
    datatable = true;
  } else {
    datatable = false;
  }

  const clearText = () => {
    setHeaderDataItem(headerListData);
    setSearchText("");
  };
  return (
    <Grid>
      {errorStatus ? (
        <NewTable
          handleclose={handlecloseerror}
          StateRespone={responsestate}
          errorStatus={errorStatus}
          Opendata={openExportNewTable}
        />
      ) : openExportNewTable ? (
        <Grid container>
          {datatable ? (
            <CardMoveTable
              onCutAddTable={onCutAddTable}
              onCopyAddTable={onCopyAddTable}
              onPasteAddTable={onPasteAddTable}
              cardopen={cardOpen}
              cardPaste={cardPaste}
              cardTableEnabled={cardTableEnabled}
            />
          ) : null}
          <Grid item xs={12} sm={12} className="mt-3" style={{ marginBottom: "25px" }}>
            <span className={classes.textMessagegrid} style={{ paddingTop: "40px" }}>
              Busca el contenido deseado y elige las columnas de la tabla que deseas exportar
            </span>
          </Grid>

          <Grid item xs={12} sm={12} className="mt-3" style={{ marginBottom: "20px" }}>
            <div>
              <span className={classes.textMessagegrid}>1.- Elige el tipo de tabla</span>
              <Dropdown
                label="Elige el tipo de tabla"
                values={tagValues}
                handleSelect={handleChangeMarket}
                value={tagSelected}
              />
            </div>
          </Grid>

          {dropdownOpen ? (
            <Grid item xs={12} sm={12} style={{ marginBottom: "20px" }}>
              <span className={classes.textMessagegrid}>2.- Elige una tabla </span>
              <Dropdown
                label="Elegir tabla..."
                values={tableValues}
                handleSelect={handleChangePredefinedTable}
                value={tableSelected}
              />
              <Grid container direction="row" justify="center" alignItems="center">
                {columnRender ? (
                  <Grid item xs={12} sm={12} className={classes.columnTitle}>
                    <span className={classes.textMessagegrid}>
                      3.-¿Deseas personalizar las columnas de la tabla a importar?{" "}
                    </span>
                    <TextField
                      onChange={handleChangeValue}
                      name="buscar"
                      id="buscar"
                      className={classes.search}
                      value={searchText}
                      placeholder="Columnas disponibles..."
                      size="small"
                      InputLabelProps={{
                        classes: {
                          root: classes.ccssLabel,
                          focused: classes.cssFocused,
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.cssOutlinedInput,
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className={classes.searchIcon} />
                          </InputAdornment>
                        ),

                        endAdornment: (
                          <InputAdornment position="end">
                            {searchText.length > 0 && <CloseIcon className={classes.searchIcon} onClick={clearText} />}
                          </InputAdornment>
                        ),
                      }}
                    />

                    <div style={{ padding: "15px 0 15px 0" }}>
                      <FormControlLabel
                        name="Seleccionar"
                        id="Seleccionar"
                        className={classes.checkBoxLabel}
                        control={
                          <Checkbox
                            className={classes.checkbox}
                            checked={checkAll}
                            onChange={(e) => allSelectedItem(e)}
                            style={{
                              transform: "scale(0.7)",
                              padding: "6px",
                            }}
                          />
                        }
                        label={<span style={{ fontSize: "13px" }}>Todas las columnas</span>}
                      />
                    </div>
                    <Grid item xs={12} sm={12} className={classes.columnDescName}>
                      <Grid container>
                        {headerDataItem.map((columnName, index) => (
                          <Grid item xs={6} sm={6} key={index} className={classes.SubcolumnDescName}>
                            {columnName.Name === "Instrumento" ? (
                              <FormControlLabel
                                className={classes.checkBoxLabelDisable}
                                control={
                                  <Checkbox
                                    className={classes.checkbox}
                                    checked={true}
                                    onChange={(e) => handleChange(e)}
                                    value={columnName.Name}
                                    style={{
                                      transform: "scale(0.7)",
                                      padding: "6px",
                                    }}
                                    disabled={true}
                                  />
                                }
                                label={
                                  <>
                                    <span style={{ fontSize: "13px" }}>{columnName.Name}</span>
                                  </>
                                }
                              />
                            ) : (
                              <FormControlLabel
                                className={classes.checkBoxGridLabel}
                                control={
                                  <Checkbox
                                    className={classes.checkbox}
                                    name="headerColumns"
                                    checked={columnName.IsChecked}
                                    onChange={(e) => handleChange(e)}
                                    value={columnName.Name}
                                    style={{
                                      transform: "scale(0.7)",
                                      padding: "6px",
                                    }}
                                  />
                                }
                                label={
                                  columnName.hasOwnProperty("newVal") ? (
                                    <>
                                      <span style={{ fontSize: "13px" }}>
                                        {columnName.newVal[0]}
                                        <span className={classes.highlightText}>{columnName.newVal[1]}</span>
                                        {columnName.newVal[2]}
                                      </span>
                                    </>
                                  ) : (
                                    <span style={{ fontSize: "13px" }}>
                                      <>{columnName.Name}</>
                                    </span>
                                  )
                                }
                              />
                            )}
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}

                <Grid item xs={12} sm={12}>
                  <PrimaryButton
                    onClick={onClickRefreshData}
                    className={clsx(classes.buttonExporter, !tableSelected ? classes.buttonDisabled : "")}
                    disabled={!tableSelected}
                  >
                    <ArrowForwardIosIcon className={classes.forwardIcon} />
                    <span>Exportar</span>
                  </PrimaryButton>
                </Grid>
              </Grid>
            </Grid>
          ) : null}

          <>
            {dataSnackbar.showSnackbar ? (
              <Snackbar
                open={dataSnackbar.showSnackbar}
                handleClose={handleCloseSnackbar}
                severity={dataSnackbar.severity}
                message={dataSnackbar.message}
                autoHideDuration={dataSnackbar.autoHideDuration}
              />
            ) : null}
          </>
        </Grid>
      ) : (
        <NewTable handleclose={handleclosesuccess} StateRespone={responsestate} Opendata={openExportNewTable} />
      )}
    </Grid>
  );
};
export const headerColumnArray = () => {
  let headersColumn = [];
  headersColumn = finalArray;
  return finalArray;
};
export default SelectPredefinedTable;
